import { phoneNumberNormalizeFunction, resolveFormValidationError, setErrorsToForm } from "@/utils/formUtils";
import { regexPatterns, validations } from "@/utils/validationUtils";
import { Form, Input, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { useCreateUserWithClientUserAccount } from "../../../../../common/api/queries/client";
import { MOBILE_NUMBER_COUNTRY_WHITELIST, ModalSizes } from "../../../../../common/constants";
import { UUID } from "../../../../../typings/global";
import { AgentCreateUserWithClientUserAccount } from "../../../../user/types";

interface Props {
  open: boolean;
  clientId: UUID;
  onFormCancel: () => void;
}

export const CreateClientUserAccountForm = (props: Props) => {
  const { t } = useTranslation();

  const [form] = Form.useForm<AgentCreateUserWithClientUserAccount>();

  const createUserWithClientUserAccount = useCreateUserWithClientUserAccount();

  const handleFormSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        createUserWithClientUserAccount.mutate(
          {
            id: props.clientId,
            object: values,
          },
          { onSuccess: props.onFormCancel, onError: (error) => setErrorsToForm(form, "user.attrs", error.violations) },
        );
      })
      .catch(resolveFormValidationError);
  };

  return (
    <Modal
      width={ModalSizes.TINY}
      open={props.open}
      title={t("user.titles.addAccount")}
      okText={t("common.save")}
      cancelText={t("common.cancel")}
      confirmLoading={createUserWithClientUserAccount.isPending}
      afterClose={() => form.resetFields()}
      onOk={handleFormSubmit}
      onCancel={props.onFormCancel}
      mask={{ closable: false }}
    >
      <Form form={form} layout="vertical" name="clientUserAccountCreateForm">
        <Form.Item
          name="name"
          label={t("user.attrs.name")}
          rules={[validations.notNull, validations.size(1, 255), validations.pattern(regexPatterns.nameRegex)]}
        >
          <Input placeholder={t("user.helpers.userNamePlaceholder")} />
        </Form.Item>

        <Form.Item
          name="email"
          label={t("user.attrs.email")}
          rules={[validations.notBlank, validations.size(1, 254), validations.email]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="phone"
          label={t("user.attrs.phone")}
          rules={[validations.notBlank, validations.mobilePhoneNumber(MOBILE_NUMBER_COUNTRY_WHITELIST)]}
          normalize={phoneNumberNormalizeFunction}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};
